import React from 'react';

import SignupForm from '../../components/login/SignupForm';
import PageLayout from '../../components/layout/PageLayout';

const SignupPage = () => (
  <PageLayout>
    <SignupForm />
  </PageLayout>
);

export default SignupPage;
